import React, { useEffect, useState } from 'react';
import { useMap } from 'react-leaflet';

// UIZoomBtnItem Component
const UIZoomBtnItem = ({ type, onClick, isDisabled, isZooming }) =>
{
	const iconClass = type === "zoom-in" ? "plus" : "minus";
	const buttonId = type === "zoom-in" ? "ui-btn-zoom-in" : "ui-btn-zoom-out";

	return (
		<button
			className={`ui-btn ${type} ${isDisabled ? 'disabled' : ''} ${isZooming ? 'zooming' : ''}`}
			id={buttonId}
			onClick={onClick}
			disabled={isDisabled}
		>
			<p className={`icon ${iconClass}`} />
		</button>
	);
};

// UIZoomBtn Component
const UIZoomBtn = ({ onClick, minZoom, maxZoom }) =>
{
	const map = useMap();
	const [zoomLevel, setZoomLevel] = useState(map.getZoom());
	const [zooming, setZooming] = useState(false);

	useEffect(() =>
	{
		const updateZoomLevel = () => setZoomLevel(map.getZoom());

		const onZoomStart = () => setZooming(true);
		const onZoomEnd = () =>
		{
			setZooming(false);
			updateZoomLevel();
		};

		map.on('zoomstart', onZoomStart);
		map.on('zoomend', onZoomEnd);

		updateZoomLevel();

		return () =>
		{
			map.off('zoomstart', onZoomStart);
			map.off('zoomend', onZoomEnd);
		};
	}, [map]);

	const handleZoom = (type) =>
	{
		if (type === "zoom-in")
		{
			onClick("zoom-in", map);
		} else if (type === "zoom-out")
		{
			onClick("zoom-out", map);
		}
	};

	const isZoomInDisabled = zoomLevel >= maxZoom;
	const isZoomOutDisabled = zoomLevel <= minZoom;

	return (
		<div className="ui-zoom-btns" data-zoom-level={zoomLevel}>
			<UIZoomBtnItem
				type="zoom-in"
				onClick={() => handleZoom("zoom-in")}
				isDisabled={isZoomInDisabled}
				isZooming={zooming}
			/>
			<UIZoomBtnItem
				type="zoom-out"
				onClick={() => handleZoom("zoom-out")}
				isDisabled={isZoomOutDisabled}
				isZooming={zooming}
			/>
		</div>
	);
};

export default UIZoomBtn;
